/* eslint-disable */
import Input from "components/Input";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import apiService from "services/apiService";
import { useForm, FormProvider } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import ImageA from "assets/nodata.jpg";
import { useToaster } from "contexts/toasterContext";
import { validateNoLeadingTrailingWhitespace } from "util/validation";
const validationSchema = yup.object({
  status: yup.string().required("status required"),
  comment: yup.string().required("Comment is required").test(
          "not-only-spaces",
          "Comment cannot be empty spaces", 
          validateNoLeadingTrailingWhitespace),
});

export default function ApproveTimesheet({
  projects,
  setApprove,
  selectedUser,
  currentYear,
  currentMonth,
}: any) {
  const methods = useForm({
    resolver: yupResolver(validationSchema),
  });
  const [selectedProject, setSelectedProject] = useState<number | null>(null);
  const [timesheet, setTimesheet] = useState<any>();
  const [projectData, setProjectData] = useState<any>();
  const { t } = useTranslation();
  const { addToast } = useToaster();
  const handleProjectChange = (selectedOption: any) => {
    setSelectedProject(selectedOption.value);
  };
  const projectOptions: { value: any; label: any }[] =
    projects && projects.length > 0
      ? projects.map((project: any) => ({
          value: project.projectId,
          label: project.name,
        }))
      : [];
  const getTimeSheetData = (payload: any) => {
    const queryParams = new URLSearchParams({
      year: payload.year.toString(),
      month: payload.month,
      ...(payload.projectId && { projectId: payload.projectId.toString() }),
      ...(payload.email && { email: payload.email }),
    });
    const url = `api/timesheet?${queryParams.toString()}`;
    return apiService.get(url);
  };
  useEffect(() => {
    const payload = {
      year: currentYear,
      month: currentMonth,
      email: selectedUser,
      projectId: selectedProject,
    };
    // if (selectedProject) {
    getTimeSheetData(payload).then((res) => {
      console.log("res :>> ", res);
      // console.log("res :>> ", res.data[0]);
      setTimesheet(res?.data[0]);
      setProjectData(res.data[0]?.data[0]);
      console.log("res.data[0]", res?.data[0]);
      console.log("res.data[0].data[0]", res?.data[0]?.data[1]);
      console.log("res.data[0].data[0]", res?.data[0]?.data[0]);
      methods.setValue("status", res.data[0]?.status);
      methods.setValue("comment", res.data[0]?.comment);
    });
    // }
  }, [selectedProject]);
  const onSubmit = (data: any) => {
    const newData = { ...timesheet, ...data };
    console.log("data", newData);
    apiService.put(`api/timesheet/${newData.id}`, newData).then((val) => {
      addToast("Time sheet is Approve successfull", "success");
      console.log("updated Data :>> ", val);
      setApprove(false);
    });
  };
  return (
    <div>
      {timesheet ? (
        <div>
          {/* <div className="flex justify-center ">
            <div className="me-2 w-64	mb-2 " style={{ zIndex: 99 }}>
              <Select
                name="project"
                options={projectOptions}
                value={projectOptions.find(
                  (option) => option.value === selectedProject
                )}
                onChange={handleProjectChange}
                placeholder={t("timesheet.selectproject")}
                className="select"
              />
            </div>
          </div> */}

          <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(onSubmit)}>
              {/* <h2 className="text-2xl font-bold mb-4">Timesheet Information</h2> */}
              {/* <div className="mb-2">
                <strong>ID:</strong> {timesheet.id}
              </div> */}
              <div className="mb-2">
                <strong className="text-gray-900 dark:text-white">Email:</strong> <span className="text-gray-700 dark:text-gray-300">{timesheet.email}</span>
              </div>
              <div className="mb-2">
                <strong className="text-gray-900 dark:text-white">Year:</strong> <span className="text-gray-700 dark:text-gray-300">{timesheet.year}</span>
              </div>
              <div className="mb-2">
                <strong className="text-gray-900 dark:text-white">Month:</strong> <span className="text-gray-700 dark:text-gray-300">{timesheet.month}</span>
              </div>

              <div className="mb-2">
                <strong className="text-gray-900 dark:text-white">Project IDs:</strong> <span className="text-gray-700 dark:text-gray-300">{timesheet.projectIds}</span>
              </div>

              <div className="mb-2">
                <strong className="text-gray-900 dark:text-white">Total Hours:</strong> <span className="text-gray-700 dark:text-gray-300">{timesheet.totalHour}</span>
              </div>
              <div className="mb-2">
                <label
                  htmlFor="status"
                  className="block text-gray-900 dark:text-white font-bold mb-2"
                >
                  Status
                </label>
                <select
                  id="status"
                  {...methods.register("status", { required: true })}
                  className={`block w-full mt-1 p-2 bg-white dark:bg-slate-700 dark:text-white border border-gray-300 dark:border-slate-600 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 `}
                >
                  <option value="InProgress">In Progress</option>
                  <option value="Submitted">Submitted</option>
                  <option value="Rejected">Rejected</option>
                  <option value="Resubmitted">Resubmitted</option>
                  <option value="ReOpen">Re Open</option>
                </select>
              </div>

              <div className="mb-2">
                <Input label="Comments" name="comment" type="textarea" />
              </div>
              <div className="flex justify-center">
                <button
                  type="submit"
                  className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                >
                  Approve
                </button>
              </div>
            </form>
          </FormProvider>
        </div>
      ) : (
        <div className="flex justify-center">
          <img src={ImageA} alt="" height={250} width={250} loading="lazy" />
        </div>
      )}
    </div>
  );
}
